// eslint-disable-next-line import/prefer-default-export
export const DEMO_API_KEY = 'key_M57QS8SMPdLdLx4x';
export const EMITTED_EVENTS = {
    PRODUCT_CARD_IMAGE_ROLLOVER: 'cio.ui-plp.productCardImageRollover',
};
